import React, { useState } from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';

interface Props {
  onSearch: (searchQuery: string) => void;
  options?: string[];
  value?: string;
}

const SearchField: React.FC<Props> = ({ onSearch, options = [], value }) => {
  const [searchQuery, setSearchQuery] = useState<string>('');

  const searchOptions = options.filter((option) => option !== '');

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  return (
    <form onSubmit={onSubmit}>
      <Autocomplete
        onInputChange={(_e: any, v: string) => setSearchQuery(v)}
        autoComplete
        options={searchOptions}
        includeInputInList
        freeSolo
        value={value}
        fullWidth
        renderInput={(params) => (
          <TextField
            autoFocus
            {...params}
            value={searchQuery}
            placeholder='Search'
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </form>
  );
};

export default SearchField;
